module.exports = __webpack_public_path__ + "assets/img/logo-new.ec7f2dc4.png";